module.exports = __webpack_public_path__ + "style/img/DI_icon_Ops.3e6730d8.png";